import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { customStyles, extract_time, formatNumber } from "../../utils/data/essential";
import { CSVLink } from "react-csv";
import { houseHeaders } from "../../utils/data/reportData";
import Locations from "../../Component/Locations"
import { selectLocationName } from "../../redux/slice/LocationNameSlice";
import { useFetchData } from "../../hooks/useFetchData";
import { columns } from "../../utils/columns/houses";
import moment from "moment";
const Houses = () => {
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const [locationId, setLocationId] = useState(user.location_id);
  const [houseData, setHouseData] = useState([])
  const locationName = useSelector(selectLocationName);

  const extractData = (data) => {
    let obj = {};
    let arr = [];
    data?.forEach((el) => {
      obj.id = el.id;
      obj.accountId = el.accountId;
      obj.location = locationName;
      obj.ownerSubscriberId = el.ownerSubscriberId;
      obj.category = el.category.name;
      obj.createdAt = moment(el.createdAt).format("DD/MM/YYYY");
      obj.securityFeeAmount = formatNumber(el.securityFeeAmount);
      obj.status = el.status.name;
      arr.push(obj);
      obj = {};
    });
    setHouseData(arr.reverse());
  };
  // Fetch houses data
  const url = `houses?locationId=${locationId}`;
  const { data, refetch } = useFetchData(["fetch-houses"],url, false,user);
  useEffect(() => {
    setLoading(false);
    extractData(data)
  }, [data]);
  const datafromChildComponent = (data) => {
    setLocationId(data.locationId);
  };
  return (
    <div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Houses</h3>
      </div>
      <Locations sendDataToParent={datafromChildComponent} />
      <div className='d-flex justify-content-center'>
        <Button
          style={{ backgroundColor: "#124db1" }}
          onClick={() => {
            setLoading(true);
            refetch();
          }}
        >
          {loading ? "Loading..." : "Search"}
        </Button>
      </div>
      {data?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={houseData}
            headers={houseHeaders}
            filename={`house_report_${extract_time()}`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={data?.length === 0}
              style={{
                backgroundColor: data?.length === 0 ? "#cbcbcb" : "#124db1",
                color: data?.length === 0 ? "#000" : "",
                cursor: data?.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}

      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={houseData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
    </div>
  );
};

export default Houses;
